import { itemsById } from "@kulturit/items-by-id";
import kitFetch from '../kit-fetch/kit-fetch';

export var APPLICATIONS_REQUESTED = 'apps/requested';
export var APPLICATIONS_RECEIVED = 'apps/received';
export var APP_RECEIVED = 'apps/appReceived';
export var APP_INFO_SET = 'apps/appInfoSet';

export var fetchApplications = function fetchApplications() {
    return function (dispatch) {
        fetchApplicationsPromise(dispatch).then(function (applications) {
            var applicationsById = itemsById(applications).items;
            dispatch(applicationsReceived(applicationsById, applications));
        });
    };
};

export var fetchApplicationsPromise = function fetchApplicationsPromise(dispatch) {
    dispatch(applicationsRequested());
    return kitFetch('/app-registry/apps/');
};

export var fetchApplication = function fetchApplication(appId) {
    return function (dispatch) {
        kitFetch('/app-registry/apps/' + appId + '/').then(function (application) {
            dispatch(appReceived(application));
        });
    };
};

export var applicationsRequested = function applicationsRequested() {
    return {
        type: APPLICATIONS_REQUESTED
    };
};

export var applicationsReceived = function applicationsReceived(applicationsById, applicationsList) {
    return {
        type: APPLICATIONS_RECEIVED,
        applications: applicationsById,
        allIds: Object.keys(applicationsById),
        applicationsList: applicationsList
    };
};

var appReceived = function appReceived(app) {
    return {
        type: APP_RECEIVED,
        title: app.title,
        theme: {
            primaryColor: app.theme.primary_color,
            lightColor: app.theme.light_color,
            darkColor: app.theme.dark_color
        },
        imageUrl: app.icon_url
    };
};

export var setAppInfo = function setAppInfo(app) {
    return function (dispatch) {
        dispatch({
            type: APP_INFO_SET,
            app: app
        });
    };
};